<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '310px'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>查询条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form ref="queryFormRef" :rules="activeName.match(/fourth|six/i) ? queryFormRules : {}" :model="queryForm" label-width="82px" size="small">
          <el-scrollbar>
            <el-form-item label="仓库" prop="inWarehouse.selected">
              <select-multiple v-bind:select-data="queryForm.inWarehouse" isScroll></select-multiple>
            </el-form-item>
            <el-form-item label="商品品牌" prop="itemBrand.selected" v-if="activeName.match(/first|second|third|fourth|six/i)">
                <select-multiple style="width: 100%;"
                    v-bind:select-data="queryForm.itemBrand" isScroll></select-multiple>
            </el-form-item>
            <el-form-item label="大类" prop="brand.selected" v-if="!activeName.match(/fourth|six/i)">
              <select-multiple v-bind:select-data="queryForm.brand" isScroll></select-multiple>
            </el-form-item>
            <el-form-item label="小类" prop="brandType.selected" v-if="!activeName.match(/fourth|six/i)">
              <select-multiple v-bind:select-data="queryForm.brandType" isScroll></select-multiple>
            </el-form-item>
            <el-form-item label="商品" prop="product.selected">
              <el-select class="select_multiple" ref="productSelectRef" v-model="queryForm.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
                <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="库存状态" prop="invStatus.selected" v-if="$store.state.power.enterpriseVersion >= 102 && activeName.match(/first|second|third|five/i)">
              <select-multiple v-bind:select-data="queryForm.invStatus" isScroll></select-multiple>
            </el-form-item>
            <el-form-item label="单据日期" prop="billDate.selected" v-if="activeName.match(/third|fourth|five|six/i)">
                <!-- <el-date-picker
                  style="width: 100%;"
                  v-model="queryForm.billDate.selected"
                  :type="activeName == 'fourth' ? 'datetimerange' : 'daterange'"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :value-format="activeName == 'fourth' ? '' : 'yyyy-MM-dd'"
                  :default-time="['00:00:00', '23:59:00']"
                  :picker-options="pickerOptions">
                </el-date-picker> -->
                <date-picker
                  style="width: 100%;"
                  v-model="queryForm.billDate.selected"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :value-format="activeName.match(/fourth|six/i) ? '' : 'yyyy-MM-dd'"
                  :picker-options="pickerOptions">
                </date-picker>
            </el-form-item>
            <el-form-item label="时间段" prop="billTime.selected" v-if="activeName.match(/fourth|six/i)">
              <el-time-picker
                style="width: 100%;"
                is-range
                v-model="queryForm.billTime.selected"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
            <!-- <el-form-item label="生产日期" prop="productionDate.selected" v-if="activeName.match(/second|third|fourth|five|six/i) && $store.state.power.isEnableProductDate == 'Y'"> -->
            <el-form-item label="生产日期" prop="productionDate.selected" v-if="activeName.match(/second|third|fourth|five|six/i)">
              <el-date-picker
                style="width: 100%;"
                v-model="queryForm.productionDate.selected"
                type="date"
                placeholder="选择生产日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="单据类型" prop="billType.selected" v-if="activeName.match(/fourth|six/i)">
              <el-select v-model="queryForm.billType.selected" placeholder="请选择单据类型" clearable style="width: 100%;" @change="changeBilltype">
                <el-option label="采购单" value="CGD" ></el-option>
                <el-option label="采购退货单" value="CGT" ></el-option>
                <el-option label="销售单" value="XSD" ></el-option>
                <el-option label="退货单" value="XST" ></el-option>
                <el-option label="调拨单" value="DBD" ></el-option>
                <el-option label="盘库单" value="PKD" ></el-option>
                <el-option label="费用单" value="FYD" ></el-option>
                <el-option label="红冲单" value="HCD" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原单据类型" prop="billTypeTwo.selected" v-if="queryForm.billType.selected == 'HCD'">
              <el-select v-model="queryForm.billTypeTwo.selected" placeholder="请选择原单据类型" multiple clearable style="width: 100%;">
                <el-option label="销售单" value="XSD" ></el-option>
                <el-option label="退货单" value="XST" ></el-option>
                <el-option label="调拨单" value="DBD" ></el-option>
                <el-option label="盘库单" value="PKD" ></el-option>
                <el-option label="费用单" value="FYD" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="filterInvItem.selected" v-if="!activeName.match(/fourth|six/i)">
              <el-checkbox v-model="queryForm.filterInvItem.selected" true-label="N" false-label="Y">{{ activeName.match(/first|second/i) ? '显示无库存商品' : '包括库房变动为0的商品' }}</el-checkbox>
            </el-form-item>
            <!-- <el-form-item prop="filterInvItem.selected" v-if="activeName.match(/first|second/i)">
              <el-checkbox v-model="isShowAllowCostPrice" v-if="allowCostPrice == 'Y'">显示库存成本</el-checkbox>
            </el-form-item> -->
          </el-scrollbar>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">查询</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main>
      <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="库房主帐" name="first" ref="first" v-if="activeName.match(/first|second/i)">
          <el-card shadow="never" v-if="activeName == 'first'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="所选库房:">
                  <span>{{ queryInfo.warehouseID }}</span>
                </el-form-item>
                <el-form-item label="大类:">
                  <span>{{ queryInfo.brandID }}</span>
                </el-form-item>
                <el-form-item label="小类:">
                  <span>{{ queryInfo.itemTypeID }}</span>
                </el-form-item>
              </div>
              <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="success">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                    <el-dropdown-item command="B">可用量拆分导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'first'" v-loading="tableLoading" style="height: calc(100% - 60px - 32px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" @sort-change="sortChange" show-summary :summary-method="getSummaries" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="55" align="center" :index="indexMethod">
                <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="warehouseName" v-if="isTrue('warehouseName')" label="库房" width="100" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.warehouseName || '全部' }}</span>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="itemName" v-if="isTrue('itemName')" label="商品" width="200" align="center" sortable="custom"></el-table-column>
                <el-table-column class-name="colspan" prop="itemSpec" v-if="isTrue('itemSpec')" label="规格" width="80" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemCode" v-if="isTrue('itemCode')" label="商品编码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salBarCode" v-if="isTrue('salBarCode')" label="大单位条码" width="130" align="center"></el-table-column>
                <el-table-column class-name="colspan" prop="midBarCode" v-if="isTrue('midBarCode')" label="中单位条码" width="130" align="center"></el-table-column>
                <el-table-column class-name="colspan" prop="invBarCode" v-if="isTrue('invBarCode')" label="小单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemBrandName" v-if="isTrue('itemBrandName')" label="商品品牌" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="brandName" v-if="isTrue('brandName')" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemTypeName" v-if="isTrue('itemTypeName')" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invOnhandQty" v-if="isTrue('invOnhandQty')" label="库存数量" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.onhandQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invOnhandQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="salOnhandQtyFormat" v-if="isTrue('salOnhandQtyFormat')" label="折算大单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midOnhandQtyFormat" v-if="isTrue('midOnhandQtyFormat')" label="折算中单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invOnhandQtyFormat" v-if="isTrue('invOnhandQtyFormat')" label="折算小单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invOrderLoadQty" v-if="isTrue('invOrderLoadQty')" label="订单占用" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.orderLoadQtyFormat }}</div>
                  <!-- <div v-if="$index % 2 === 0">
                    <el-link type="primary" @click="toJump(row)">{{ row.orderLoadQtyFormat }}</el-link>
                  </div> -->
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invOrderLoadQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="invConversionOrderLoadQtyFormat" v-if="isTrue('invConversionOrderLoadQtyFormat')" label="折算小单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midConversionOrderLoadQtyFormat" v-if="isTrue('midConversionOrderLoadQtyFormat')" label="折算中单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salConversionOrderLoadQtyFormat" v-if="isTrue('salConversionOrderLoadQtyFormat')" label="折算大单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invAvailableQty" v-if="isTrue('invAvailableQty')" label="可用量" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.availableQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invAvailableQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionInvQtyFormat" v-if="isTrue('availableConversionInvQtyFormat')" label="折算小单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionMidQtyFormat" v-if="isTrue('availableConversionMidQtyFormat')" label="折算中单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionSalQtyFormat" v-if="isTrue('availableConversionSalQtyFormat')" label="折算大单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="costTotalAmt" label="库存成本" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('costTotalAmt')" sortable="costTotalAmt"></el-table-column>
              <el-table-column class-name="colspan" prop="salCostPrice" label="大单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('salCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="midCostPrice" label="中单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('midCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="invCostPrice" label="小单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('invCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="salTotalAmt" v-if="isTrue('salTotalAmt')" label="库存货值" align="center" width="100" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="salPrice" v-if="isTrue('salPrice')" label="大单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="midPrice" v-if="isTrue('midPrice')" label="中单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="invPrice" v-if="isTrue('invPrice')" label="小单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" v-if="isTrue('itemWeight')" label="重量(Kg)" width="90" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeightTon" v-if="isTrue('itemWeightTon')" label="重量(吨)" width="90" align="center"></el-table-column>
            </el-table>
          </div>
          <el-pagination v-if="activeName == 'first'" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="库房明细" name="second" ref="second" :lazy="true" v-if="activeName.match(/first|second/i)">
          <el-card shadow="never" v-if="activeName == 'second'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="生产日期:" v-if="$store.state.power.isEnableProductDate == 'Y'">
                  <span>{{ queryInfo.productionDate }}</span>
                </el-form-item>
                <el-form-item label="所选库房:">
                  <span>{{ queryInfo.warehouseID }}</span>
                </el-form-item>
                <el-form-item label="大类:">
                  <span>{{ queryInfo.brandID }}</span>
                </el-form-item>
                <el-form-item label="小类:">
                  <span>{{ queryInfo.itemTypeID }}</span>
                </el-form-item>
              </div>
              <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="success">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                    <el-dropdown-item command="B">可用量拆分导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'second'" v-loading="tableLoading" style="height: calc(100% - 60px - 32px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" @sort-change="sortChange" show-summary :summary-method="getSummaries" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="55" align="center" :index="indexMethod">
                <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="warehouseName" v-if="isTrue('warehouseName')" label="库房" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemName" v-if="isTrue('itemName')" label="商品" width="200" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemSpec" v-if="isTrue('itemSpec')" label="规格" width="80" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemCode" v-if="isTrue('itemCode')" label="商品编码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salBarCode" v-if="isTrue('salBarCode')" label="大单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midBarCode" v-if="isTrue('midBarCode')" label="中单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invBarCode" v-if="isTrue('invBarCode')" label="小单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemBrandName" v-if="isTrue('itemBrandName')" label="商品品牌" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="brandName" v-if="isTrue('brandName')" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemTypeName" v-if="isTrue('itemTypeName')" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="productionDate" v-if="$store.state.power.isEnableProductDate == 'Y' && isTrue('productionDate')" label="生产日期" width="100" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invOnhandQty" v-if="isTrue('invOnhandQty')" label="库存数量" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.onhandQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invOnhandQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="salOnhandQtyFormat" v-if="isTrue('salOnhandQtyFormat')" label="折算大单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midOnhandQtyFormat" v-if="isTrue('midOnhandQtyFormat')" label="折算中单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invOnhandQtyFormat" v-if="isTrue('invOnhandQtyFormat')" label="折算小单位库存数量" width="160" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invOrderLoadQty" v-if="isTrue('invOrderLoadQty')" label="订单占用" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">
                    <el-link v-if="row.invOrderLoadQty && Number(row.invOrderLoadQty)" type="primary" @click="toJump(row)">{{ row.orderLoadQtyFormat }}</el-link>
                    <span v-else>{{ row.orderLoadQtyFormat }}</span>
                  </div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invOrderLoadQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="invConversionOrderLoadQtyFormat" v-if="isTrue('invConversionOrderLoadQtyFormat')" label="折算小单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midConversionOrderLoadQtyFormat" v-if="isTrue('midConversionOrderLoadQtyFormat')" label="折算中单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salConversionOrderLoadQtyFormat" v-if="isTrue('salConversionOrderLoadQtyFormat')" label="折算大单位订单占用" width="180" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="invAvailableQty" v-if="isTrue('invAvailableQty')" label="可用量" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.availableQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.invAvailableQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionInvQtyFormat" v-if="isTrue('availableConversionInvQtyFormat')" label="折算小单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionMidQtyFormat" v-if="isTrue('availableConversionMidQtyFormat')" label="折算中单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="availableConversionSalQtyFormat" v-if="isTrue('availableConversionSalQtyFormat')" label="折算大单位可用量" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="costTotalAmt" v-if="isTrue('costTotalAmt') && isShowAllowCostPrice && allowCostPrice == 'Y'" label="库存成本" align="center" width="100" sortable="costTotalAmt"></el-table-column>
              <el-table-column class-name="colspan" prop="salCostPrice" label="大单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('salCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="midCostPrice" label="中单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('midCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="invCostPrice" label="小单位成本价" align="center" width="100" v-if="isShowAllowCostPrice && allowCostPrice == 'Y' && isTrue('invCostPrice')"></el-table-column>
              <el-table-column class-name="colspan" prop="salTotalAmt" v-if="isTrue('salTotalAmt')" label="库存货值" align="center" width="100" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="salPrice" v-if="isTrue('salPrice')" label="大单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="midPrice" v-if="isTrue('midPrice')" label="中单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="invPrice" v-if="isTrue('invPrice')" label="小单位价格" align="center" width="100"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" v-if="isTrue('itemWeight')" label="重量(Kg)" width="90" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeightTon" v-if="isTrue('itemWeightTon')" label="重量(吨)" width="90" align="center"></el-table-column>
              
              
            </el-table>
          </div>
          <el-pagination v-if="activeName == 'second'" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="按库房商品汇总" name="third" ref="third" :lazy="true" v-if="activeName.match(/third|five/i)">
          <el-card shadow="never" v-if="activeName == 'third'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="生产日期:" v-if="$store.state.power.isEnableProductDate == 'Y'">
                  <span>{{ queryInfo.productionDate }}</span>
                </el-form-item>
                <el-form-item label="单据日期:">
                  <span>{{ queryInfo.beginDate }}</span>
                  <span style="margin: 0 6px;">至</span>
                  <span>{{ queryInfo.endDate }}</span>
                </el-form-item>
                <el-form-item label="所选库房:">
                  <span>{{ queryInfo.warehouseID }}</span>
                </el-form-item>
                <el-form-item label="大类:">
                  <span>{{ queryInfo.brandID }}</span>
                </el-form-item>
                <el-form-item label="小类:">
                  <span>{{ queryInfo.itemTypeID }}</span>
                </el-form-item>
              </div>
              <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="success">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'third'" v-loading="tableLoading" style="height: calc(100% - 60px - 32px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" @sort-change="sortChange" show-summary :summary-method="getSummaries" @row-dblclick="handleTableDBClick" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="55" align="center" :index="indexMethod">
                <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="warehouseName" v-if="isTrue('warehouseName')" label="库房" width="100" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.warehouseName || '全部' }}</span>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="itemName" v-if="isTrue('itemName')" label="商品" width="200" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemSpec" v-if="isTrue('itemSpec')" label="规格" width="80" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemCode" v-if="isTrue('itemCode')" label="商品编码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salBarCode" v-if="isTrue('salBarCode')" label="大单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midBarCode" v-if="isTrue('midBarCode')" label="中单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invBarCode" v-if="isTrue('invBarCode')" label="小单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="brandName" v-if="isTrue('brandName')" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemTypeName" v-if="isTrue('itemTypeName')" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="productionDate" v-if="isTrue('productionDate') && $store.state.power.isEnableProductDate == 'Y'" label="生产日期" width="100" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="yesterdayInvQtyFormat" v-if="isTrue('yesterdayInvQtyFormat')" label="昨日库存" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.yesterdayInvQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.yesterdayInvQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenInQtyFormat" v-if="isTrue('betweenInQtyFormat')" label="入库" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index}">
                  <div v-if="$index % 2 === 0">{{ row.betweenInQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenInQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenOutQtyFormat" v-if="isTrue('betweenOutQtyFormat')" label="出库" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenOutQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenOutQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenSalQtyFormat" v-if="isTrue('betweenSalQtyFormat')" label="销售" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenSalQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenSalQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenSalReturnQtyFormat" v-if="isTrue('betweenSalReturnQtyFormat')" label="销售退货" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenSalReturnQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenSalReturnQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenAdjustQtyFormat" v-if="isTrue('betweenAdjustQtyFormat')" label="调整" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenAdjustQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenAdjustQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenLossesQtyFormat" v-if="isTrue('betweenLossesQtyFormat')" label="报损" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenLossesQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenLossesQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="todayInvQtyFormat" v-if="isTrue('todayInvQtyFormat')" label="今日库存" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.todayInvQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.todayInvQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="salBillPrice" v-if="isTrue('salBillPrice')" label="标准价" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salTotalAmt" v-if="isTrue('salTotalAmt')" label="库存货值" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="costBillPrice" v-if="isTrue('costBillPrice') && allowCostPrice == 'Y'" label="成本价" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="costTatalAmt" v-if="isTrue('costTatalAmt') && allowCostPrice == 'Y'" label="成本总金额" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" v-if="isTrue('itemWeight')" label="今日库存重量" width="90" align="center"></el-table-column>
              
              
            </el-table>
          </div>
          <el-pagination v-if="activeName == 'third'" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="按商品汇总" name="five" ref="five" :lazy="true" v-if="activeName.match(/third|five/i)">
          <el-card shadow="never" v-if="activeName == 'five'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="生产日期:" v-if="$store.state.power.isEnableProductDate == 'Y'">
                  <span>{{ queryInfo.productionDate }}</span>
                </el-form-item>
                <el-form-item label="单据日期:">
                  <span>{{ queryInfo.beginDate }}</span>
                  <span style="margin: 0 6px;">至</span>
                  <span>{{ queryInfo.endDate }}</span>
                </el-form-item>
                <el-form-item label="所选库房:">
                  <span>{{ queryInfo.warehouseID }}</span>
                </el-form-item>
                <el-form-item label="大类:">
                  <span>{{ queryInfo.brandID }}</span>
                </el-form-item>
                <el-form-item label="小类:">
                  <span>{{ queryInfo.itemTypeID }}</span>
                </el-form-item>
              </div>
              <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="success">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'five'" v-loading="tableLoading" style="height: calc(100% - 60px - 32px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" @sort-change="sortChange" show-summary :summary-method="getSummaries" @row-dblclick="handleTableDBClick" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="55" align="center" :index="indexMethod">
                <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="itemName" v-if="isTrue('itemName')" label="商品" width="200" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemSpec" v-if="isTrue('itemSpec')" label="规格" width="80" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemCode" v-if="isTrue('itemCode')" label="商品编码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salBarCode" v-if="isTrue('salBarCode')" label="大单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midBarCode" v-if="isTrue('midBarCode')" label="中单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invBarCode" v-if="isTrue('invBarCode')" label="小单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="brandName" v-if="isTrue('brandName')" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemTypeName" v-if="isTrue('itemTypeName')" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="productionDate" v-if="isTrue('productionDate') && $store.state.power.isEnableProductDate == 'Y'" label="生产日期" width="100" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="yesterdayInvQtyFormat" v-if="isTrue('yesterdayInvQtyFormat')" label="昨日库存" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.yesterdayInvQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.yesterdayInvQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenInQtyFormat" v-if="isTrue('betweenInQtyFormat')" label="入库" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index}">
                  <div v-if="$index % 2 === 0">{{ row.betweenInQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenInQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenOutQtyFormat" v-if="isTrue('betweenOutQtyFormat')" label="出库" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenOutQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenOutQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenSalQtyFormat" v-if="isTrue('betweenSalQtyFormat')" label="销售" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenSalQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenSalQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenSalReturnQtyFormat" v-if="isTrue('betweenSalReturnQtyFormat')" label="销售退货" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenSalReturnQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenSalReturnQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenAdjustQtyFormat" v-if="isTrue('betweenAdjustQtyFormat')" label="调整" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenAdjustQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenAdjustQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="betweenLossesQtyFormat" v-if="isTrue('betweenLossesQtyFormat')" label="报损" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.betweenLossesQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.betweenLossesQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="todayInvQtyFormat" v-if="isTrue('todayInvQtyFormat')" label="今日库存" width="100" align="center" sortable="custom">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.todayInvQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.todayInvQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="salBillPrice" v-if="isTrue('salBillPrice')" label="标准价" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salTotalAmt" v-if="isTrue('salTotalAmt')" label="库存货值" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="costBillPrice" v-if="isTrue('costBillPrice') && allowCostPrice == 'Y'" label="成本价" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="costTatalAmt" v-if="isTrue('costTatalAmt') && allowCostPrice == 'Y'" label="成本总金额" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" v-if="isTrue('itemWeight')" label="今日库存重量" width="90" align="center"></el-table-column>
              
            </el-table>
          </div>
          <el-pagination v-if="activeName == 'five'" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="库房流水(按生产日期)" name="fourth" ref="fourth" :lazy="true" v-if="activeName.match(/fourth|six/i)">
          <el-card shadow="never" v-if="activeName == 'fourth'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="单据日期:">
                  <span>{{ queryInfo.beginDate }}</span>
                  <span style="margin: 0 6px;">至</span>
                  <span>{{ queryInfo.endDate }}</span>
                </el-form-item>
                <el-form-item label="所选库房:">
                  <span>{{ queryInfo.warehouseID }}</span>
                </el-form-item>
                <el-form-item label="大类:">
                  <span>{{ queryInfo.brandID }}</span>
                </el-form-item>
                <el-form-item label="小类:">
                  <span>{{ queryInfo.itemTypeID }}</span>
                </el-form-item>
              </div>
              <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="success">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'fourth'" v-loading="tableLoading" style="height: calc(100% - 10px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" @row-dblclick="handleTableDBClick" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="55" align="center" :index="indexMethod">
                <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="outWarehouseName" v-if="isTrue('outWarehouseName')" label="出库库房" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="inWarehouseName" v-if="isTrue('inWarehouseName')" label="入库库房" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemName" v-if="isTrue('itemName')" label="商品" width="200" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemSpec" v-if="isTrue('itemSpec')" label="规格" width="80" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemCode" v-if="isTrue('itemCode')" label="商品编码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="salBarCode" v-if="isTrue('salBarCode')" label="大单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="midBarCode" v-if="isTrue('midBarCode')" label="中单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="invBarCode" v-if="isTrue('invBarCode')" label="小单位条码" width="130" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="brandName" v-if="isTrue('brandName')" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="itemTypeName" v-if="isTrue('itemTypeName')" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
              <el-table-column class-name="colspan" prop="dateTime" v-if="isTrue('dateTime')" label="制单时间" width="160" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="sourceBillNoID" v-if="isTrue('sourceBillNoID')" label="来源单号" width="170" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="productionDate" v-if="isTrue('productionDate') && $store.state.power.isEnableProductDate == 'Y'" label="生产日期" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="ioType" v-if="isTrue('ioType')" label="出入库类型" width="100" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="changeQty" v-if="isTrue('changeQty')" label="变动数量" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.changeQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.changeQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="changeQtyStr" v-if="isTrue('changeQtyStr')" label="变动数量(折算小单位)" width="145" align="center"></el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="surplusQty" v-if="isTrue('surplusQty')" label="库存剩余数量" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.surplusQtyFormat }}</div>
                  <div v-if="$index % 2 !== 0 && $store.state.power.showInvUnitNum == 'Y'" class="border">
                    <span>折算</span>
                    <span>{{ row.surplusQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :class-name="$store.state.power.showInvUnitNum == 'Y' ? '' : 'colspan'" prop="surplusQtyStr" v-if="isTrue('surplusQtyStr')" label="剩余库存数量(折算小单位)" width="175" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="customerName" v-if="isTrue('customerName')" label="供应商/客户" width="100" align="center"></el-table-column>
              
              <el-table-column class-name="colspan" prop="transTypeFormat" v-if="isTrue('transTypeFormat')" label="单据类型" width="80" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" v-if="isTrue('itemWeight')" label="剩余重量(Kg)" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeightTon" v-if="isTrue('itemWeightTon')" label="剩余重量(吨)" width="100" align="center"></el-table-column>
               <el-table-column class-name="colspan" prop="remark" v-if="isTrue('remark')" label="备注" width="100" align="center"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="库房流水(不按生产日期)" name="six" ref="six" :lazy="true" v-if="activeName.match(/fourth|six/i)">
          <turnover ref="turnover" @emitDblclick="handleTableDBClick"></turnover>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-dialog title="自定义显示列" :visible.sync="customColumnDialogVisible" :close-on-click-modal="false" width="20%">
      <customColumns ref="customColumns" v-if="customColumnDialogVisible"  @confirm="closeCustomColumns"></customColumns>
    </el-dialog>
    <el-dialog :visible.sync="selectProductVisible" width="70%" :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :default-checked-keys="queryForm.product.list"></selectProduct>
    </el-dialog>
    <el-drawer
      size="70%"
      custom-class="detail_drawer"
      :visible.sync="drawer"
      @close="drawerClose"
      :with-header="false">
      <el-container>
        <el-header>
          <el-row>
            <el-col :span="8"><label>仓库名称：</label><span>{{ drawerHeaderInfo.warehouseName }}</span></el-col>
            <el-col :span="8"><label>商品名称：</label><span>{{ drawerHeaderInfo.itemName }}</span></el-col>
            <el-col :span="8"><label>规格型号：</label><span>{{ drawerHeaderInfo.itemSpec }}</span></el-col>
            <el-col :span="8" v-if="$store.state.power.isEnableProductDate == 'Y'"><label>生产日期：</label><span>{{ drawerHeaderInfo.productionDate }}</span></el-col>
            <el-col :span="8"><label>出库数量：</label><span>{{ drawerHeaderInfo.betweenOutQtyFormat }}</span></el-col>
            <el-col :span="8"><label>入库数量：</label><span>{{ drawerHeaderInfo.betweenInQtyFormat }}</span></el-col>
            <el-col :span="8"><label>调整数量：</label><span>{{ drawerHeaderInfo.betweenAdjustQtyFormat }}</span></el-col>
            <el-col :span="8"><label>销售数量：</label><span>{{ drawerHeaderInfo.betweenSalQtyFormat }}</span></el-col>
            <el-col :span="8"><label>销售退货数量：</label><span>{{ drawerHeaderInfo.betweenSalReturnQtyFormat }}</span></el-col>
          </el-row>
        </el-header>
        <el-main>
          <el-tabs v-model="drawerActiveName" @tab-click="drawerTabClick(drawerHeaderInfo)">
            <el-tab-pane label="全部" name="empty"></el-tab-pane>
            <el-tab-pane label="入库" name="A"></el-tab-pane>
            <el-tab-pane label="出库" name="B"></el-tab-pane>
            <el-tab-pane label="调整" name="C"></el-tab-pane>
            <el-tab-pane label="销售" name="D"></el-tab-pane>
            <el-tab-pane label="销售退货" name="E"></el-tab-pane>
            <el-tab-pane label="报损" name="F"></el-tab-pane>
          </el-tabs>
          <div class="tabForm">
              <el-checkbox v-model="isContainRed" true-label="Y" false-label="N" @change="drawerTabClick(drawerHeaderInfo)">包含红冲</el-checkbox>
            </div>
          <div class="drawer_table" v-loading="drawerTableLoading">
            <el-table :data="drawerTableData" style="width: 100%" border stripe height="100%" max-height="100%" :span-method="objectSpanMethod">
              <el-table-column class-name="colspan" type="index" width="40" align="center" :index="indexMethod"></el-table-column>
              <el-table-column prop="dateTime" label="发生时间/来源单号" width="160" align="center">
                <template slot-scope="{ row, $index  }">
                  <div v-if="$index % 2 === 0">{{ row.dateTime}}</div>
                  <div v-else class="border" v-show="row.sourceBillNoID">{{ row.sourceBillNoID }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="itemName" label="商品/规格" width="200" align="center">
                <template slot-scope="{ row, $index  }">
                  <div v-if="$index % 2 === 0">{{ row.itemName}}</div>
                  <div v-else class="border" v-show="row.itemSpec">{{ row.itemSpec }}</div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="productionDate" label="生产日期" width="100" align="center" v-if="$store.state.power.isEnableProductDate == 'Y'"></el-table-column>
              <el-table-column prop="changeQty" label="变动数量" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.changeQtyFormat }}</div>
                  <div v-else class="border">
                    <span>折算</span>
                    <span>{{ row.changeQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="surplusQty" label="库存剩余数量" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <div v-if="$index % 2 === 0">{{ row.surplusQtyFormat }}</div>
                  <div v-else class="border">
                    <span>折算</span>
                    <span>{{ row.surplusQty }}</span>
                    <span>{{ row.invUnitName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column class-name="colspan" prop="customerName" label="供应商/客户" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="outWarehouseName" label="出库库房" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="inWarehouseName" label="入库库房" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="ioType" label="出入库类型" width="100" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="transTypeFormat" label="单据类型" width="80" align="center"></el-table-column>
              <el-table-column class-name="colspan" prop="itemWeight" label="剩余重量(Kg)" width="100" align="center"></el-table-column>
              <!-- <el-table-column class-name="colspan" prop="itemWeightTon" label="剩余重量(吨)" width="100" align="center"></el-table-column> -->
            </el-table>
          </div>
        </el-main>
      </el-container>
    </el-drawer>
    <el-drawer
      size="70%"
      custom-class="order_detail_drawer"
      :visible.sync="orderDrawer"
      destroy-on-close
      @close="drawerClose"
      :with-header="false">
      <orderDetailDialog ref="orderDetailDialog" :visible.sync="orderDrawer" :tabs-active-arr="tabsActiveArr" :location-search="locationSearch" :power="power"></orderDetailDialog>
    </el-drawer>
  </el-container>
</template>

<script>
import selectProduct from '@/components/common/selectProduct.vue'
import datePicker from '@/components/common/datePicker.vue'
import orderDetailDialog from '@/components/common/orderDetailDialog.vue'
import turnover from '@/views/dataSearch/stock/Turnover.vue'
import customColumns from '@/components/common/customColumns.vue'
import { toRawType, pickerOptions, getNowFormatDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: "InventoryQuery",
  props: ['tag'],
  components: {
    selectProduct,
    orderDetailDialog,
    datePicker,
    turnover,
    customColumns
  },
  data() {
    let activeName = 'first'
    let begin = new Date()
    let end = new Date()
    begin.setHours(0)
    begin.setMinutes(0)
    begin.setSeconds(0)
    end.setHours(23)
    end.setMinutes(59)
    end.setSeconds(59)
    let beginDate = getNowFormatDate()
    let endDate = getNowFormatDate()
    if (this.tag == 'A') {
      activeName = 'first'
    } else if (this.tag == 'B') {
      activeName = 'second'
    } else if (this.tag == 'C') {
      activeName = 'third'
    } else if (this.tag == 'D') {
      activeName = 'fourth'
      beginDate = getNowFormatDate(begin, 'yyyy-MM-dd hh:mm:ss')
      endDate = getNowFormatDate(end, 'yyyy-MM-dd hh:mm:ss')
    }
    return {
      isCollapse: false,
      activeName: activeName,
      drawerActiveName: 'empty',
      selectProductVisible: false,
      queryForm: {
        inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 10}, text: '', value: '' }},
        itemBrand: { submitName: 'itemBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 10, isEnabled: 'Y' }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: {page: 1, size: 10, isPage: 'Y'}, text: '', value: ''}},
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: {page: 1, size: 10, isPage: 'Y'}, text: '', value: ''}},
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        invStatus: { submitName: 'invStatus', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择库存状态', request: { url: '/Account/dataSearchVue/selectInvStatusList.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        productionDate: { submitName: 'productionDate', selected: '' },
        filterInvItem: { submitName: 'isHaveStock', selected: 'Y' },
        sortField: { submitName: 'sortField', selected: '' },
        billType: { submitName: 'billType', selected: '' },
        billTypeTwo: { submitName: 'billTypeTwo', selected: '' },
        softBy: { submitName: 'softBy', selected: '' },
        billDate: { submitName: 'billDate', selected: activeName == 'fourth' ? [ begin, end ] : [ beginDate, endDate ], format: 'yyyy-MM-dd' },
        billTime: { submitName: 'billTime', selected: [ begin, end ], format: 'hh:mm:ss' }
      },
      isShowAllowCostPrice: true,
      pickerOptions: pickerOptions,
      tableLoading: false,
      tableData: [],
      summaries: {},
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      queryInfo: {
        productionDate: '无',
        warehouseID: '全部',
        brandID: '全部',
        itemTypeID: '全部',
        beginDate,
        endDate
      },
      queryFormRules: {
        'inWarehouse.selected': [
          { required: true, message: '请选择仓库', trigger: 'blur' }
        ],
      },
      priceArgs: {
        url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
        code: 'isInventoryReport'
      },
      allowCostPrice: 'N',
      // drawer
      drawer: false,
      drawerHeaderInfo: {},
      drawerTableData: [],
      drawerTableLoading: false,
      isContainRed: 'Y',
      // drawer
      // orderDrawer
      orderDrawer: false,
      tabsActiveArr: [],
      tabList: [
        {
          value: 'A',
          billSearchType: 'XSD',
          text: '销售出库',
          badgeVal: 0,
          checked: true
        },
        {
          value: 'B',
          billSearchType: 'XSD',
          text: '还货',
          badgeVal: 0
        },
        {
          value: 'C',
          billSearchType: 'XSD',
          text: '换货',
          badgeVal: 0
        },
        {
          value: 'A',
          billSearchType: 'XST',
          text: '退货入库',
          badgeVal: 0
        },
        {
          value: 'C',
          billSearchType: 'XST',
          text: '换货',
          badgeVal: 0
        },
        {
          value: 'A',
          billSearchType: 'CGD',
          text: '采购进货',
          badgeVal: 0
        },
        {
          value: 'A',
          billSearchType: 'CGT',
          text: '采购退货',
          badgeVal: 0
        },
        {
          value: 'A',
          billSearchType: 'PKD',
          text: '盘点',
          badgeVal: 0
        }
      ],
      locationSearch: {
        tag: ''
      },
      power: {},
      customColumnDialogVisible: false,
      customColumn: [],
      customColumnList: {
        first: [{ "label": "库房", "prop": "warehouseName" }, { "label": "商品", "prop": "itemName" }, { "label": "规格", "prop": "itemSpec" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品品牌", "prop": "itemBrandName" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "库存数量", "prop": "invOnhandQty" }, { "label": "折算大单位库存数量", "prop": "salOnhandQtyFormat" }, { "label": "折算中单位库存数量", "prop": "midOnhandQtyFormat" }, { "label": "折算小单位库存数量", "prop": "invOnhandQtyFormat" }, { "label": "订单占用", "prop": "invOrderLoadQty" }, { "label": "折算大单位订单占用", "prop": "salConversionOrderLoadQtyFormat" }, { "label": "折算中单位订单占用", "prop": "midConversionOrderLoadQtyFormat" }, { "label": "折算小单位订单占用", "prop": "invConversionOrderLoadQtyFormat" }, { "label": "可用量", "prop": "invAvailableQty" }, { "label": "折算大单位可用量", "prop": "availableConversionSalQtyFormat" }, { "label": "折算中单位可用量", "prop": "availableConversionMidQtyFormat" }, { "label": "折算小单位可用量", "prop": "availableConversionInvQtyFormat" }, { "label": "库存成本", "prop": "costTotalAmt" }, { "label": "大单位成本价", "prop": "salCostPrice" }, { "label": "中单位成本价", "prop": "midCostPrice" }, { "label": "小单位成本价", "prop": "invCostPrice" }, { "label": "库存货值", "prop": "salTotalAmt" }, { "label": "大单位价格", "prop": "salPrice" }, { "label": "中单位价格", "prop": "midPrice" }, { "label": "小单位价格", "prop": "invPrice" },{ "label": "重量(Kg)", "prop": "itemWeight" }, { "label": "重量(吨)", "prop": "itemWeightTon" }, { "label": "备注", "prop": "remark" }],
        second: [{ "label": "库房", "prop": "warehouseName" }, { "label": "商品", "prop": "itemName" }, { "label": "规格", "prop": "itemSpec" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品品牌", "prop": "itemBrandName" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "生产日期", "prop": "productionDate" }, { "label": "库存数量", "prop": "invOnhandQty" }, { "label": "折算大单位库存数量", "prop": "salOnhandQtyFormat" }, { "label": "折算中单位库存数量", "prop": "midOnhandQtyFormat" }, { "label": "折算小单位库存数量", "prop": "invOnhandQtyFormat" }, { "label": "订单占用", "prop": "invOrderLoadQty" }, { "label": "折算大单位订单占用", "prop": "salConversionOrderLoadQtyFormat" }, { "label": "折算中单位订单占用", "prop": "midConversionOrderLoadQtyFormat" }, { "label": "折算小单位订单占用", "prop": "invConversionOrderLoadQtyFormat" }, { "label": "可用量", "prop": "invAvailableQty" }, { "label": "折算大单位可用量", "prop": "availableConversionSalQtyFormat" }, { "label": "折算中单位可用量", "prop": "availableConversionMidQtyFormat" }, { "label": "折算小单位可用量", "prop": "availableConversionInvQtyFormat" }, { "label": "库存成本", "prop": "costTotalAmt" }, { "label": "大单位成本价", "prop": "salCostPrice" }, { "label": "中单位成本价", "prop": "midCostPrice" }, { "label": "小单位成本价", "prop": "invCostPrice" }, { "label": "库存货值", "prop": "salTotalAmt" }, { "label": "大单位价格", "prop": "salPrice" }, { "label": "中单位价格", "prop": "midPrice" }, { "label": "小单位价格", "prop": "invPrice" }, { "label": "重量(Kg)", "prop": "itemWeight" }, { "label": "重量(吨)", "prop": "itemWeightTon" }, { "label": "备注", "prop": "remark" }],
        third: [{ "label": "库房", "prop": "warehouseName" }, { "label": "商品", "prop": "itemName" }, { "label": "规格", "prop": "itemSpec" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "生产日期", "prop": "productionDate" }, { "label": "昨日库存", "prop": "yesterdayInvQtyFormat" }, { "label": "入库", "prop": "betweenInQtyFormat" }, { "label": "出库", "prop": "betweenOutQtyFormat" }, { "label": "销售", "prop": "betweenSalQtyFormat" }, { "label": "销售退货", "prop": "betweenSalReturnQtyFormat" }, { "label": "调整", "prop": "betweenAdjustQtyFormat" }, { "label": "报损", "prop": "betweenLossesQtyFormat" }, { "label": "今日库存", "prop": "todayInvQtyFormat" }, { "label": "标准价", "prop": "salBillPrice" }, { "label": "库存货值", "prop": "salTotalAmt" }, { "label": "成本价", "prop": "costBillPrice" }, { "label": "成本总金额", "prop": "costTatalAmt" }, { "label": "今日库存重量", "prop": "itemWeight" }],
        five: [{ "label": "商品", "prop": "itemName" }, { "label": "规格", "prop": "itemSpec" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "生产日期", "prop": "productionDate" }, { "label": "昨日库存", "prop": "yesterdayInvQtyFormat" }, { "label": "入库", "prop": "betweenInQtyFormat" }, { "label": "出库", "prop": "betweenOutQtyFormat" }, { "label": "销售", "prop": "betweenSalQtyFormat" }, { "label": "销售退货", "prop": "betweenSalReturnQtyFormat" }, { "label": "调整", "prop": "betweenAdjustQtyFormat" }, { "label": "报损", "prop": "betweenLossesQtyFormat" }, { "label": "今日库存", "prop": "todayInvQtyFormat" }, { "label": "标准价", "prop": "salBillPrice" }, { "label": "库存货值", "prop": "salTotalAmt" }, { "label": "成本价", "prop": "costBillPrice" }, { "label": "成本总金额", "prop": "costTatalAmt" }, { "label": "今日库存重量", "prop": "itemWeight" }],
        fourth: [{ "label": "出库库房", "prop": "outWarehouseName" }, { "label": "入库库房", "prop": "inWarehouseName" }, { "label": "商品", "prop": "itemName" }, { "label": "规格", "prop": "itemSpec" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "制单时间", "prop": "dateTime" }, { "label": "来源单号", "prop": "sourceBillNoID" }, { "label": "生产日期", "prop": "productionDate" }, { "label": "出入库类型", "prop": "ioType" }, { "label": "变动数量", "prop": "changeQty" }, { "label": "变动数量(折算小单位)", "prop": "changeQtyStr" }, { "label": "库存剩余数量", "prop": "surplusQty" }, { "label": "剩余库存数量(折算小单位)", "prop": "surplusQtyStr" }, { "label": "供应商/客户", "prop": "customerName" }, { "label": "单据类型", "prop": "transTypeFormat" }, { "label": "剩余重量(Kg)", "prop": "itemWeight" }, { "label": "剩余重量(吨)", "prop": "itemWeightTon" }, { "label": "备注", "prop": "remark" }],
      },
      customColumnForRemoteList: []
      // orderDrawer
    }
  },
  computed: {
    queryitem () {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') return
          if (item.submitName == 'billTime') return
          if(item.submitName == 'invStatus'){
            tempItem[item.submitName] = item.selected.map(i => i.value).join(',')
          }else {
            tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',')
          }
        } else if (toRawType(item.selected) == 'String') {
          tempItem[item.submitName] = item.selected
        } else if (toRawType(item.selected) == 'Object') {
          tempItem[item.submitName] = item.selected.value
        }
      })
      
      if (this.activeName == 'first') {
        tempItem['isSearchDetail'] = 'Y'
        tempItem['warehouseName'] = this.queryForm.inWarehouse.selected.map(i => "'" + i.text + "'").join(',')
      } else if (this.activeName == 'second') {
        tempItem['isSearchDetail'] = 'N'
        tempItem['warehouseName'] = this.queryForm.inWarehouse.selected.map(i => "'" + i.text + "'").join(',')
      } else if (this.activeName.match(/third|five/i)) {
        tempItem['beginDate'] = this.queryForm.billDate?.selected[0] || ''
        tempItem['endDate'] = this.queryForm.billDate?.selected[1] || ''
        tempItem['warehouseName'] = this.queryForm.inWarehouse.selected.map(i => "'" + i.text + "'").join(',')
        tempItem['isTransOrChange'] = 'N'
        // 库存流水（双击查看明细）需要用到
        tempItem['isContainRed'] = this.isContainRed
        tempItem['ioType'] = this.drawerActiveName == 'empty' ? '' : this.drawerActiveName
        // 是否为按商品汇总或按库房商品汇总
        tempItem['isSearchWarehouse'] = this.activeName == 'third' ? 'Y' : 'N'
      } else if (this.activeName == 'fourth') {
        let begin = this.queryForm.billDate?.selected[0]
        let end = this.queryForm.billDate?.selected[1]
        tempItem['beginDate'] = getNowFormatDate(begin, 'yyyy-MM-dd') || ''
        tempItem['endDate'] = getNowFormatDate(end, 'yyyy-MM-dd') || ''
        tempItem['beginTime'] = getNowFormatDate(this.queryForm.billTime?.selected[0], 'hh:mm:ss') || ''
        tempItem['endTime'] = getNowFormatDate(this.queryForm.billTime?.selected[1], 'hh:mm:ss') || ''
        tempItem['warehouseName'] = this.queryForm.inWarehouse.selected.text || ''
        tempItem['isTransOrChange'] = 'Y'
        if(this.queryForm.billTypeTwo.selected.length) {
          tempItem['billTypeTwo'] = this.queryForm.billTypeTwo.selected.join(',')
        } else {
          tempItem['billTypeTwo'] = ''
        }
      }
      
      tempItem['page'] = this.pagination.page
      tempItem['size'] = this.pagination.size
      return tempItem
    }
  },
  created() {
    this.allowCostPrice = this.$store.state.power.allowCostPrice
    if(this.$store.state.power.enterpriseVersion >= 100){
        this.getPriceShow()
    }
    let unwatch = this.$watch('$store.state.power', (val) => {
        this.allowCostPrice = val.allowCostPrice
        if(val.enterpriseVersion >= 100){
          this.getPriceShow()
        }
        unwatch()
    })
    if (this.activeName == 'fourth') {
      this.getPower()
      return false
    }
    this.getTableData()
    this.getCustomColumnForRemoteList()
  },
  methods: {
    tabClick() {
      this.queryForm.sortField.selected = ''
      this.queryForm.softBy.selected = ''
      this.pagination.page = 1
      this.pagination.size = 10
      this.pagination.total = 0
      this.tableData = []
      this.summaries = {}
      if (this.activeName == 'six') {
        this.$nextTick(() => {
          let turnover = this.$refs.turnover
          turnover.getCustomColumnsList()
        })
      } else {
        this.getCustomColumnForRemoteList()
      }
      this.onSubmit()
    },
    productInputFocus () {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    async getPriceShow() { 
      const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
      this.allowCostPrice = res.result
    },
    getProductData (data) {
      this.$set(this.queryForm.product, 'list', data)
      this.queryForm.product.selected = data
      this.selectProductVisible = false
    },
    productChange(val) {
      this.queryForm.product.list = val
    },
    async getTableData () {
      this.tableLoading = true
      let url = '/Account/invMasterVueSearch/invItemMaster.html'
      if (this.activeName.match(/first|second/i)) {
        url = '/Account/invMasterVueSearch/invItemMaster.html'
      } else if (this.activeName.match(/third|five/i)) {
        url = '/Account/invMasterVueSearch/selectInvItemChange.html'
      } else if (this.activeName == 'fourth') {
        url = '/Account/invMasterVueSearch/selectInvItemTrans.html'
      }
      try {
        const { data: res } = await this.$http.post(url, this.Qs.stringify(this.queryitem))
        this.tableLoading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let { total, data, sum } = JSON.parse(res.result)
        this.pagination.total = total
        let tempArr = []
        if (data) {
          JSON.parse(data).forEach(i => {
            tempArr.push(i)
            tempArr.push(i)
          })
        }
        this.tableData = tempArr
        this.summaries = sum ? JSON.parse(sum) : {}
      } catch(e) {
        console.log(e)
        this.tableLoading = false
      }
    },
    async getdrawerTableData (args) {
      this.drawerTableLoading = true
      let tempItem = { ...this.queryitem, ...args }
      const { data: res } = await this.$http.post('/Account/invMasterVueSearch/selectInvItemTrans.html', this.Qs.stringify(tempItem))
      this.drawerTableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { data } = JSON.parse(res.result)
      let tempArr = []
      if (data) {
        JSON.parse(data).forEach(i => {
          tempArr.push(i)
          tempArr.push(i)
        })
      }
      this.drawerTableData = tempArr
    },
    onSubmit() {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') return false
          if (item.submitName == 'billTime') return false
          tempItem[item.submitName] = item.selected.length ? item.selected.map(i => i.text) : '全部'
        } else if (toRawType(item.selected) == 'String') {
          tempItem[item.submitName] = item.selected ? item.selected : '无'
        }
      })
      if (this.activeName == 'fourth') {
        if (!this.queryitem.warehouseID) return this.$message.warning('请先选择仓库')
        if (!this.queryitem.itemID && !this.queryitem.itemBrandID) return this.$message.warning('请选择商品或商品品牌')
        tempItem['beginDate'] = getNowFormatDate(this.queryForm.billDate?.selected[0], 'yyyy-MM-dd') + ' ' + getNowFormatDate(this.queryForm.billTime?.selected[0], 'hh:mm:ss')
        tempItem['endDate'] = getNowFormatDate(this.queryForm.billDate?.selected[1], 'yyyy-MM-dd') + ' ' + getNowFormatDate(this.queryForm.billTime?.selected[1], 'hh:mm:ss')
      } else if (this.activeName == 'third') {
        tempItem['beginDate'] = this.queryForm.billDate?.selected[0] || ''
        tempItem['endDate'] = this.queryForm.billDate?.selected[1] || ''
      } else if (this.activeName == 'five') {
        tempItem['beginDate'] = this.queryForm.billDate?.selected[0] || ''
        tempItem['endDate'] = this.queryForm.billDate?.selected[1] || ''
      }
      this.queryInfo = tempItem
      this.pagination = {
        page: 1,
        size: 20,
        total: 0
      }
      if (this.activeName == 'six') {
        if (!this.queryitem.warehouseID) return this.$message.warning('请先选择仓库')
        if (!this.queryitem.itemID && !this.queryitem.itemBrandID) return this.$message.warning('请选择商品或商品品牌')
        this.$nextTick(() => {
          let turnover = this.$refs.turnover
          turnover.formModel = this.queryForm
          turnover.formSubmit()
        })
      } else {
        this.getTableData()
      }
    },
    onReset () {
      this.$refs['queryFormRef'].resetFields()
    },
    indexMethod(index) {
      let $index = ((this.pagination.page - 1) * this.pagination.size) + ((index + 2) / 2)
      return $index
    },
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 != 0) {
        return 'el-table__row--striped'
      }
    },
    handleSizeChange (newSize) {
      this.pagination.size = newSize
      this.getTableData()
    },
    handleCurrentChange (newPage) {
      this.pagination.page = newPage
      this.getTableData()
    },
    sortChange ({ prop, order }) {
      let orderStr = ''
      if (order == 'descending') {
        orderStr = 'DESC'
      } else if (order == 'ascending') {
        orderStr = 'ASC'
      }
      this.queryForm.sortField.selected = prop.split('/')[0]
      this.queryForm.softBy.selected = orderStr
      this.getTableData()
    },
    getSummaries ({ columns }) {
      const sums = []
      for (let k in this.summaries) {
        columns.forEach((column, index) => {
          if (index == 1) {
            sums[index] = '合计'
            return
          }
          if (column.property == k) {
            sums[index] = this.summaries[k]
            return
          }
        })
      }
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
      return sums
    },
    objectSpanMethod({ column, rowIndex }) {
      if (column.className == 'colspan') {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getCustomColumnForRemoteList(isOpenDialog = false) {
      let funcCode = null
      // this.customColumn = []
      if (this.activeName == 'first') {
        funcCode = '422'
      } else if (this.activeName == 'second') {
        funcCode = '423'
      } else if (this.activeName == 'third') {
        funcCode = '424'
      } else if (this.activeName == 'five') {
        funcCode = '425'
      } else if (this.activeName == 'fourth') {
        funcCode = '426'
      }
      if (funcCode == null) return false
      this.$nextTick(async () => {
        const { data: res } = await this.$http.post(
          "Account/dataSearchVue/selectColumnByFuncCode.html",
          this.Qs.stringify({ funcCode })
        );
        if (res.code != "success") return this.$confirm(res.message, "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "error",
        });
        let result = JSON.parse(res.result);
        let arr = [];
        this.customColumnList[this.activeName].forEach((item) => {
          result.forEach(($item) => {
            if (item.prop == 'costTotalAmt' && !(this.isShowAllowCostPrice && this.allowCostPrice == 'Y')) return false
            if (item.prop == 'salCostPrice' && !(this.isShowAllowCostPrice && this.allowCostPrice == 'Y')) return false
            if (item.prop == 'midCostPrice' && !(this.isShowAllowCostPrice && this.allowCostPrice == 'Y')) return false
            if (item.prop == 'invCostPrice' && !(this.isShowAllowCostPrice && this.allowCostPrice == 'Y')) return false
            if (item.prop == 'productionDate' && !(this.$store.state.power.isEnableProductDate == 'Y')) return false
            if (item.prop == 'costBillPrice' && !(this.allowCostPrice == 'Y')) return false
            if (item.prop == 'costTatalAmt' && !(this.allowCostPrice == 'Y')) return false
            if (item.prop == $item.prop) {
              arr.push({
                id: $item.id,
                label: item.label,
                prop: item.prop,
                isShow: $item.isShow,
              });
            }
          });
        });
        this.customColumn = [...arr]
        // this.customColumn = JSON.parse(JSON.stringify(arr))
        if (isOpenDialog) this.$nextTick(async () => {
          this.$refs.customColumns.loading = false
          this.$refs.customColumns.setCustomcolumns(JSON.parse(JSON.stringify(this.customColumn)))
        })
      })
    },
    getCustomColumns() {
      this.customColumnDialogVisible = true
      this.getCustomColumnForRemoteList(true)
    },
    async closeCustomColumns(isSubmit) {
        if(!isSubmit){
            this.customColumnDialogVisible = false
            return
        }
      let funcCode = null
      if (this.activeName == 'first') {
        funcCode = '422'
      } else if (this.activeName == 'second') {
        funcCode = '423'
      } else if (this.activeName == 'third') {
        funcCode = '424'
      } else if (this.activeName == 'five') {
        funcCode = '425'
      } else if (this.activeName == 'fourth') {
        funcCode = '426'
      }
      if (funcCode == null) return false
      let { customColumns } = this.$refs.customColumns
      const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
        funcCode: funcCode,
        customSetInfo: JSON.stringify(customColumns)
      }))
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      this.customColumnDialogVisible = false
      this.getCustomColumnForRemoteList(true)
    },
    isTrue(prop = '') {
      let flag = false
      if (!this.customColumn.length) return false
      try {
        let index = this.customColumn.findIndex(i => i.prop == prop)
        if (index > -1) {
          flag = this.customColumn[index]['isShow'] == 'Y'
        } else {
          flag = true
        }
      } catch (error) {
        // console.log(error);
      }
      return flag
    },
    handleCommand (command) {
      let $table = this.$refs.table
      let exportExcelUrl = ''
      if (this.activeName.match(/first|second/i)) {
        exportExcelUrl = command == 'A' ? '/Account/invMasterVueSearch/exportInvItemMasterExcel.html' : '/Account/invMasterVueSearch/exportInvItemMasterExcelWithSplit.html'
      } else if (this.activeName.match(/third|five/i)) {
        exportExcelUrl = '/Account/invMasterVueSearch/exportInvItemChangeExcel.html'
      } else if (this.activeName == 'fourth') {
        exportExcelUrl = '/Account/invMasterVueSearch/exportInvItemTransExcel.html'
      }
      if (command.match(/A|B/i)) {
        console.log(exportExcelUrl)
        this.exportExcel(exportExcelUrl, $table)
      }
    },
    exportExcel (url, $table) {
      let tempArr = $table.$children.map(item => {
        if (item.prop && item.prop.match(/\//)) {
          let label = item.label.split('/')
          let prop = item.prop.split('/')
          return [
            {
              label: label[0],
              prop: prop[0]
            },
            {
              label: label[1],
              prop: prop[1]
            }
          ]
        } else {
          return {
            label: item.label,
            prop: item.prop
          }
        }
      }).filter(item => (item.prop || Array.isArray(item))).flat()
      let arr = []
      this.customColumnList[this.activeName].forEach(i => {
        tempArr.forEach(j => {
          if (i.prop == j.prop) {
            arr.push(j)
          }
        })
      })
      if (url) {
        exportExcelCommonForVue(this.queryitem, arr, url)
      }
      console.log(arr)
    },
    handleTableDBClick(row) {
      const toAddTab = (sourceBillType) => {
        let flag = false
        try {
          let timestemp = new Date().getTime()
          console.log("🚀 ~ toAddTab ~ timestemp:", timestemp)
          let width = window.top.document.browser.availiframeWidth.value
          let height = window.top.document.browser.availiframeHeight.value
          if (sourceBillType == 'DH') {
            flag = true
            top.addPanel('订还货订单详情', `/yunsierp3/index.html#/enterPage/repayEntry?billNo=${row.sourceBillNoID}&billType=${sourceBillType}&timestemp=${timestemp}`, width, height, true)
          } else if (sourceBillType == 'FX') {
            flag = true
            top.addPanel('访销单详情', `/yunsierp3/index.html#/order/fangxiaoOrder?billNo=${ row.sourceBillNoID }&billType=${sourceBillType}&timestemp=${timestemp}`, width, height, true)
          } else if (sourceBillType == 'JOD') {
            flag = true
            top.addPanel('还货单明细', `/yunsierp3/index.html#/reportForms/returnReportDetail?billNo=${ row.sourceBillNoID }&timestemp=${timestemp}`, width, height, true)
          } else if (sourceBillType == 'FOD') {
            flag = true
            top.addPanel('陈列协议明细', `/yunsierp3/index.html#/reportForms/goodsDetails?cashBillNo=${ row.sourceBillNoID }&timestemp=${timestemp}`, width, height, true)
          }
        } catch (error) {
          console.log("🚀 ~ toAddTab ~ error:", error)
          console.log('跳转失败');
        }
        return flag
      }
      if (this.activeName == 'third') {
        this.drawer = true
        this.drawerHeaderInfo = row
        this.drawerTabClick(row)
      } else if (this.activeName == 'fourth') {
        let { transType, sourceBillNoID, sourceBillType } = row
        console.log("🚀 ~ handleTableDBClick ~ transType:", row)
        if (!transType || transType.match(/HCD|FYD/i)) return
        if (!sourceBillNoID) return
        if (toAddTab(sourceBillType)) return false        
        this.tabsActiveArr[0] = this.tabList.filter(i => i.billSearchType == transType)[0]?.value || ''
        this.locationSearch.tag = transType
        this.orderDrawer = true
        this.$nextTick(() => {
          let orderDetailDialog = this.$refs['orderDetailDialog']
          // 获取单据详情事件
          orderDetailDialog.getDetailInfo({ billNo: sourceBillNoID, billType: transType })
          // 获取单据分品牌欠款详情事件
          orderDetailDialog.getBarandArrearDetailInfo({ billNo: sourceBillNoID, billType: transType })
        })
      } else if(this.activeName == 'six') {
        let { transTypeCode, sourceBillNoID, sourceBillType } = row
        console.log("🚀 ~ handleTableDBClick ~ transTypeCode:", row)
        if (!transTypeCode || transTypeCode.match(/HCD|FYD/i)) return
        if (!sourceBillNoID) return
        if (toAddTab(sourceBillType)) return false  
        this.tabsActiveArr[0] = this.tabList.filter(i => i.billSearchType == transTypeCode)[0]?.value || ''
        this.locationSearch.tag = transTypeCode
        this.orderDrawer = true
        this.$nextTick(() => {
          let orderDetailDialog = this.$refs['orderDetailDialog']
          // 获取单据详情事件
          orderDetailDialog.getDetailInfo({ billNo: sourceBillNoID, billType: transTypeCode })
          // 获取单据分品牌欠款详情事件
          orderDetailDialog.getBarandArrearDetailInfo({ billNo: sourceBillNoID, billType: transTypeCode })
        })
      }
    },
    // 获取权限
    async getPower() {
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColAndAuthByFuncCode.html', this.Qs.stringify({ funcCode: 201 }))
      // this.isGetPower = true
      res.result = JSON.parse(res.result)
      this.power = JSON.parse(res.result.data)
      this.getCustomColumnForRemoteList()
    },
    drawerTabClick (row) {
      console.log(row)
      let { warehouseID, warehouseName, itemID, productionDate } = row
      this.getdrawerTableData({ warehouseID, warehouseName, itemID: "'" + itemID + "'", productionDate })
    },
    drawerClose () {
      this.drawerHeaderInfo = {}
      this.drawerTableData = []
      this.drawerActiveName = 'empty'
      this.isContainRed = 'Y'
    },
    changeBilltype() {
      this.queryForm.billTypeTwo.selected = ''
    },
    toJump({ warehouseID, warehouseName, itemID, itemName, productionDate }) {
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      top.addPanel('订单占用查询', `/templates/vue-account/dist/index.htm#/orderOccupy?${this.Qs.stringify({ warehouseID, warehouseName, itemID, itemName, productionDate })}`, width, height, true)
      // this.$router.push('/orderOccupy')
    }
  }
};
</script>

<style scoped lang="less">
#tab {
  // height: calc(100vh - 20px);
  .el-aside {
    .box-card {
      height: calc(100% - 2px);
      ::v-deep .el-card__header {
        padding: 8px 20px;
        height: 33px;
      }
      ::v-deep .el-card__body {
        padding: 6px;
        height: calc(100% - 33px);
        .el-form {
          height: calc(100% - 48px);
          .el-scrollbar {
            height: 100%;
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
          }
        }
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
  .el-main {
    padding: 0 0 0 6px;
    .el-tabs {
      height: calc(100% - 2px);
      box-shadow: none;
      ::v-deep .el-tabs__item {
        height: 34px;
        line-height: 34px;
      }
      ::v-deep .el-tabs__content {
        height: calc(100% - 33px);
        padding: 0 12px 0;
        .el-tab-pane {
          height: 100%;
          display: flex;
          flex-flow: column;
          .el-card__body {
            padding: 12px;
            .el-form {
              height: 33px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              overflow: auto;
              & > div:nth-child(1) {
                height: 33px;
                display: flex;
                overflow: auto;
                flex-wrap: wrap;
                flex: 1;
              }
              .el-form-item {
                margin: 0 10px 0 0;
              }
              .el-form-item.dropdown {
                margin: 0;
                width: 101px;
              }
            }
          }
          .table {
            flex: 1;
            // height: calc(100% - 60px - 32px);
            box-sizing: border-box;
            .el-table {
              th, td {
                padding: 0;
                .cell {
                  font-size: 14px;
                  padding: 0;
                }
              }
              .border {
                font-size: 12px;
                // color: #f56c6c;
                // border-top: 1px solid rgb(235, 238, 245);
              }
            }
          }
        }
        #tab {
          padding: 0;
          .el-card__body {
            padding: 12px;
          }
          .tabs-body {
            padding: 0;
          }
          .top-from {
            padding: 12px;
            margin: 0;
          }
        }
      }
    }
  }
  .detail_drawer {
    display: flex;
    flex-flow: column;
    .el-container {
      height: 100%;
    }
    .el-header {
      height: auto !important;
      .el-row .el-col {
        margin-top: 12px;
        color: #303133;
      }
    }
    .el-main {
      display: flex;
      flex-flow: column;
      position: relative;
      flex: 1;
      .el-tabs {
        height: 48px;
        ::v-deep .el-tabs__content {
          display: none;
        }
      }
      .tabForm {
        position: absolute;
        height: 34px;
        line-height: 34px;
        top: 0;
        right: 12px;
      }
      .drawer_table {
        flex: 1;
        ::v-deep .el-table {
          th, td {
            padding: 0;
            .cell {
              font-size: 14px;
              padding: 0;
            }
          }
          .border {
            font-size: 12px;
            // color: #f56c6c;
            border-top: 1px solid rgb(235, 238, 245);
          }
        }
      }
    }
  }
  ::v-deep .product-dialog {
    min-width: 1080px;
  }
}


</style>
